module.exports = __webpack_public_path__ + "static/media/sign.44940ff4.png";